import React, { useState, useEffect }  from 'react';
import { useMsal, useAccount } from "@azure/msal-react";
import jQuery from 'jquery';
import CONFIG from '../config';

import * as Utils from '../lib/utils';

window.jQuery = jQuery;
require("jsgrid");


//nested data is ok, see accessorKeys in ColumnDef below  
const Employee = (props) => {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [employeeData, setEmployeeData] = useState(null);
  const [managersData, setManagersData] = useState(null);
  const [directReportsData, setDirectReportsData] = useState(null);
  const [salaryHistoryData, setSalaryHistoryData] = useState(null);

  const [employeeSalary, setEmployeeSalary] = useState(null);
  
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);

  const urlParams = Utils.getParams();

  const isNotProd = CONFIG.debug || CONFIG.staging;
  const impUser = isNotProd ? localStorage.getItem("impersonated_user") : "";
  const accountUserEmail = isNotProd && impUser ? impUser : accounts[0].username; 
  // console.log("accountUserEmail", accountUserEmail);
  // console.log("props", props);
  const isAdmin =
    props &&
    props.userAccount &&
    props.userAccount.access_level &&
    props.userAccount.access_level.indexOf("ADMIN") > -1;
  const isModerator =
    props &&
    props.userAccount &&
    props.userAccount.access_level &&
    props.userAccount.access_level.indexOf("MODERATOR") > -1;
  // console.log(isAdmin, isModerator)

  useEffect(() => {
    const fetchData = async () => {
      if (!employeeData || !managersData || !directReportsData) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }

      try {
          const jsonEmployeeResponse = await Utils.getData(
            ('/api/employee/' + urlParams.id + "?viewer_email=" + accountUserEmail + "&salary_year=" + (new Date()).getFullYear()), 
            instance, 
            account
          );
          // console.log("RESPONSE JSON employeeUrl:", jsonEmployeeResponse);

          const jsonManagersResponse = await Utils.getData(
            ('/api/employee/' + urlParams.id + '/managers'), 
            instance, 
            account
          );
          // console.log("RESPONSE JSON managersUrl:", jsonManagersResponse);   

          const jsonReportsResponse = await Utils.getData(
            ('/api/employee/' + urlParams.id + '/directReports'), 
            instance, 
            account
          );

          const jsonSalaryHistoryResponse = await Utils.getData(
            ('/api/salary_history/' + urlParams.id), 
            instance, 
            account
          );
          // console.log("RESPONSE JSON jsonSalaryHistoryResponse:", jsonSalaryHistoryResponse);

          setEmployeeData(jsonEmployeeResponse);
          setManagersData(jsonManagersResponse);
          setDirectReportsData(jsonReportsResponse);
          setSalaryHistoryData(jsonSalaryHistoryResponse);

          setEmployeeSalary(jsonEmployeeResponse.current_ft_annualized_salary)

      } catch (error) {
        setIsError(true);
        console.error(error);
        return;
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  let orgHeiarchy = [];
  let nextId = 0;
  
  //get managers from CEO down
  // console.log("managersData", managersData);

  const renderEmployeeName = (userText, employee, loggedInUser)=>{
    // console.log("USER DETAILS:", userText, employee, loggedInUser);
    if(
      (
        loggedInUser.permitted_hris_users 
        && loggedInUser.permitted_hris_users.indexOf(employee.employee_hris_id) > -1
      )
      || (
        loggedInUser.access_level
        && (
          loggedInUser.access_level.indexOf("ADMIN") > -1 ||
          loggedInUser.access_level.indexOf("MODERATOR") > -1
        )
      ) 
    ){
      return <a href={"/employee?id=" + employee.id}>{userText}</a>;
    }else if(employee.employee_hris_id === loggedInUser.employee_hris_id){
      return <a href="/dashboard">{userText}</a>;
    }else{
      return userText
    }
  }
  // console.log("props", props);

  if(managersData && managersData.length){
      for(var i=0;i<managersData.length;i++){
          const thisUser = managersData.find((element)=>{ return element.manager_hris_id === nextId });
          // console.log("thisUser", thisUser, "managersData", managersData)
          
          orgHeiarchy.push(
              <div className="managersNode" key={Utils.guid()}>
                  <div className={"managerDetails" + (i===managersData.length-1 ? " bold" : "")}>
                      { 
                        renderEmployeeName(
                          (
                            Utils.decodeHTML(thisUser.first_name) + " " + 
                            Utils.decodeHTML(thisUser.last_name) + 
                            (i === managersData.length-1 ? " (Selected User)" : "")
                          ),
                          thisUser,
                          props && props.userAccount ? props.userAccount : {}
                        ) 
                      }
                  </div>
                  {(i !== managersData.length-1 || (directReportsData && directReportsData.length) ? (<div> --&gt;</div>) : "")}
              </div>
          );
          nextId = thisUser.employee_hris_id;
      }    
  }
  //last item currently in list is selected employee

  //get direct reports if there are any
  if(directReportsData && directReportsData.length){
      const handleDirectReports = (reportsData) => {
        // console.log("reportsData",reportsData)
        let reportUsers = [];
        for(var i=0;i<reportsData.length;i++){
            reportUsers.push(
              <div key={Utils.guid()} className="directReportUser">                
                { 
                  renderEmployeeName(
                    (Utils.decodeHTML(reportsData[i].first_name) + " " + Utils.decodeHTML(reportsData[i].last_name)),
                    reportsData[i],
                    props && props.userAccount ? props.userAccount : {}
                  ) 
                }
              </div>);
        }
        return <div key={Utils.guid()} className="directReportsNode">{reportUsers}</div>
      }
      orgHeiarchy.push(handleDirectReports(directReportsData));
  }

  // const dateOfHireObject = employeeData && employeeData.date_of_hire ? new Date(employeeData.date_of_hire) : new Date();
  const baseDOHString = employeeData && employeeData.date_of_hire ? employeeData.date_of_hire.substring(0,10) : ""; //Utils.maskDateAs("mdy", dateOfHireObject);
  const dateOfHireString = baseDOHString ? baseDOHString.substring(5,7) + "/" + 
    baseDOHString.substring(8,10) + "/" + 
    baseDOHString.substring(0,4) : "";
  //if not authorized, show message indicating so
  //otherwise, show loading until employee profile fetches
  // const employeeHrisId = props && props.userAccount && props.userAccount.employee_hris_id ? props.userAccount.employee_hris_id : null;
  const employeeHrisId = employeeData ? employeeData.employee_hris_id : -1;
  // console.log("employeeData", employeeData);

  return employeeData && employeeData.result === "UNAUTHORIZED" ? <div>Unauthorized</div> :
    (!isLoading && employeeData ? 
      (<div>
        {employeeHrisId && directReportsData.length ? <div><a style={{fontWeight:"bold"}} href={"/compensation?managerHrisId="+employeeHrisId}>Go to employees's compensation page</a><br /></div> : null}
        {employeeHrisId && directReportsData.length && (isAdmin || isModerator) ? <div><a style={{fontWeight:"bold"}} href={"/dashboard?employeeHrisId="+employeeData.employee_hris_id + "&employeeId="+employeeData.id + "&accountEmail="+employeeData.email}><br />Go to employees's dashboard</a><br /><br /></div> : null}
        <div className={"header"}>Employee Profile:</div> 
        <div><b>Employee Name:</b> {Utils.decodeHTML(employeeData.first_name)} {Utils.decodeHTML(employeeData.last_name)}</div>
        <div><b>Employee HRIS ID:</b> {employeeData.employee_hris_id}</div>
        <div><b>Position Title:</b> {employeeData.position_title}</div>
        <div><b>Location:</b> {employeeData.location === "Remote" ? employeeData.remote_city : employeeData.location}, {employeeData.resident_state}</div>
        <div><b>Date of Hire:</b> {dateOfHireString}</div>
        <div><b>Hours/Week:</b> {employeeData.hours_week}</div>
        {/* <div><b>Labor Name:</b> {employeeData.labor_name}</div> */}
        <div><b>FLSA Status:</b> {employeeData.exempt_nonexempt === "Exempt" ? "Salaried" : "Hourly"}</div>
        {/* <div><b>Education:</b> {employeeData.education}</div> */}
        <div><b>Employment Status:</b> {employeeData.status}</div>

        <div>&nbsp;</div>
        {/* <div><b>Salary Department:</b> {employeeData.group_department}</div> */}
        <div><b>Salary Range:(<strong>Most recent - {employeeData.period_start ? employeeData.period_start.substring(0,4) : null}</strong>)</b> &nbsp;
          {employeeData.minimum ? Utils.moneyMask(employeeData.minimum) : "N/A"} 
          &nbsp; - {employeeData.midpoint ? Utils.moneyMask(employeeData.midpoint) : "N/A"} 
          &nbsp; - {employeeData.maximum ? Utils.moneyMask(employeeData.maximum) : "N/A"}
        </div>
        <div>&nbsp;</div>

        <div><b>Organization Structure:</b></div>
        <div className="orgHeiarchy">{orgHeiarchy}</div>

        <div>&nbsp;</div>

        <div><b>Current Salary:</b> {Utils.moneyMask(employeeSalary)}</div>
        <div>&nbsp;</div>
        <div className="salaryHistory">
            <div className={"header"}>Salary History:</div>
            <div>&nbsp;</div>
            <div>
              <span className={"salaryHistoryHeader header"}>Position</span>
              <span className={"salaryHistoryHeader header"}>Effective Date</span>
              <span className={"salaryHistoryHeader header"}>FT Annualized Salary</span>
            </div>
            <div className="salaryHistoryItemList">
              {
                salaryHistoryData ? salaryHistoryData.map((adjustmentEntry)=>{                  
                  const baseDateString = adjustmentEntry && adjustmentEntry.salary_change_effective_date ? 
                    adjustmentEntry.salary_change_effective_date.substring(0,10) : "";
                  const dateString = baseDateString ? baseDateString.substring(5,7) + "/" + 
                    baseDateString.substring(8,10) + "/" + 
                    baseDateString.substring(0,4) : "";
                  return <div className={"salaryHistoryRow"} key={Utils.guid()}>
                    <span className={"salaryHistoryItem"}>{Utils.decodeHTML(adjustmentEntry.position_name)}</span>
                    <span className={"salaryHistoryItem"}>{dateString}</span>
                    <span className={"salaryHistoryItem"}>{Utils.moneyMask(parseInt(adjustmentEntry.ft_annualized_salary))}</span>
                  </div>
                }) : null
              }
            </div>
        </div>
      </div>) : <div>Loading...</div>
    );
};

export default Employee;